import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { retry } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ErrorModalComponent } from '../errorhandler/error-modal/error-modal.component';
import { EmployeeInvitationRedirectStatus } from '../lead-form-app/model/employee-invitation.model';
import { AuthenticationService } from '../authentication/authentication.service';
import { EmployeeInvitationService } from '../lead-form-app/service/employee-invitation.service';
import { TenantService } from '../authentication/tenant.service';
import { Observable } from 'rxjs';
import { Tenant } from '../lead-form-app/model/tenant.model';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-employee-invitation-confirmation',
  templateUrl: './employee-invitation-confirmation.component.html',
  styleUrls: ['./employee-invitation-confirmation.component.scss']
})
export class EmployeeInvitationConfirmationComponent {

  invitationStatus: EmployeeInvitationRedirectStatus;
  invitationId: string;
  errorCode: string;
  codeViaSms: boolean;
  callbackPath: string;

  twoFactorFormControl = new FormControl('', [Validators.required]);
  patchingCode: boolean;

  $tenant: Observable<Tenant>;

  constructor(private activatedRoute: ActivatedRoute, private authenticationService: AuthenticationService,
              private employeeInvitationService: EmployeeInvitationService, private matDialog: MatDialog,
              private tenantService: TenantService) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.invitationStatus = params.status;
      this.errorCode = params.errorCode;
      this.invitationId = params.invitationId;
      this.codeViaSms = params.codeViaSms === 'true';
      this.callbackPath = params.callbackPath ? decodeURIComponent(params.callbackPath) : undefined;
      if (this.callbackPath && window.location.host.startsWith('localhost')) {
        this.callbackPath = this.callbackPath.replace('/partner', '');
      }
      const tenantId = params.tenantId;
      if (this.invitationStatus === EmployeeInvitationRedirectStatus.SUCCESS.valueOf()) {
        const path = this.callbackPath || '/tng';
        this.authenticationService.triggerLoginWithCallback(window.location.protocol + '//' + window.location.host + path);
      }
      if (this.invitationStatus === EmployeeInvitationRedirectStatus.WAITING_FOR_TWO_FACTOR_CODE.valueOf()) {
        this.authenticationService.triggerLogin();
      }
      if (tenantId) {
        this.$tenant = tenantService.getTenantById(tenantId);
      }
    });
  }

  confirmTwoFactorCode() {
    this.patchingCode = true;
    this.authenticationService.triggerLogin();
    this.employeeInvitationService.patchTwoFactorCode(this.invitationId, this.twoFactorFormControl.value)
      .pipe(retry(10)).subscribe(
      invitation => {
        if (invitation.status === 'FINISHED') {
          const path = this.callbackPath || '/tng';
          window.location.href = window.location.protocol + '//' + window.location.host + path;
        } else {
          this.invitationStatus = EmployeeInvitationRedirectStatus.WAITING_FOR_TWO_FACTOR_CODE;
          this.twoFactorFormControl.setErrors({invalid: 'true'});
        }
        this.patchingCode = false;
      },
      error => this.matDialog.open(ErrorModalComponent, {data: error})
    );
  }
}
